import { defineMessage } from "react-intl";

export const DOCUMENTS_TYPES_VALUE_CUSTOMER = "customer";
export const DOCUMENTS_TYPES_VALUE_HOLDER = "holder";

export const DOCUMENTS_TYPES = {
  [DOCUMENTS_TYPES_VALUE_CUSTOMER]: {
    value: DOCUMENTS_TYPES_VALUE_CUSTOMER,
    label: defineMessage({ defaultMessage: "Comptes famille" }),
    labelPlural: defineMessage({ defaultMessage: "Comptes famille" }),
    description: defineMessage({
      defaultMessage: "Document destiné à un compte famille",
    }),
  },
  [DOCUMENTS_TYPES_VALUE_HOLDER]: {
    value: DOCUMENTS_TYPES_VALUE_HOLDER,
    label: defineMessage({ defaultMessage: "Adhérent" }),
    labelPlural: defineMessage({ defaultMessage: "Adhérents" }),
    description: defineMessage({
      defaultMessage: "Document destiné aux adhérents",
    }),
  },
};

export const DOCUMENTS_TYPES_LIST = Object.values(DOCUMENTS_TYPES);

// ============================================================

export const DOCUMENTS_HOLDER_TYPES_VALUE_CUSTOMER = "child";
export const DOCUMENTS_HOLDER_TYPES_VALUE_HOLDER = "member";

/**
 * @type {Object<string, {
 * value: import("../types/Document").DocumentHolderType,
 * label: import("react-intl").MessageDescriptor,
 * labelPlural: import("react-intl").MessageDescriptor,
 * description: import("react-intl").MessageDescriptor,
 * }>}
 */
export const DOCUMENTS_HOLDER_TYPES = {
  [DOCUMENTS_HOLDER_TYPES_VALUE_CUSTOMER]: {
    value: DOCUMENTS_HOLDER_TYPES_VALUE_CUSTOMER,
    label: defineMessage({ defaultMessage: "Enfant" }),
    labelPlural: defineMessage({ defaultMessage: "Enfants" }),
    description: defineMessage({
      defaultMessage: "Document destiné aux enfants",
    }),
  },
  [DOCUMENTS_HOLDER_TYPES_VALUE_HOLDER]: {
    value: DOCUMENTS_HOLDER_TYPES_VALUE_HOLDER,
    label: defineMessage({ defaultMessage: "Adulte" }),
    labelPlural: defineMessage({ defaultMessage: "Adultes" }),
    description: defineMessage({
      defaultMessage: "Document destiné aux adultes",
    }),
  },
};

export const DOCUMENTS_HOLDER_TYPES_LIST = Object.values(
  DOCUMENTS_HOLDER_TYPES,
);

// ============================================================

export const DOCUMENTS_SORT_VALUE_DATE_ASC = "created_asc";
export const DOCUMENTS_SORT_VALUE_DATE_DESC = "created_desc";

export const DOCUMENTS_SORTS = {
  [DOCUMENTS_SORT_VALUE_DATE_ASC]: {
    value: DOCUMENTS_SORT_VALUE_DATE_ASC,
    message: defineMessage({ defaultMessage: "Date de création croissante" }),
  },
  [DOCUMENTS_SORT_VALUE_DATE_DESC]: {
    value: DOCUMENTS_SORT_VALUE_DATE_DESC,
    message: defineMessage({ defaultMessage: "Date de création décroissante" }),
  },
};

export const DOCUMENTS_SORT_LIST = Object.values(DOCUMENTS_SORTS);
